// extracted by mini-css-extract-plugin
export default {"root":"cardList-module__root--t7aBW","notFoundTitle":"cardList-module__notFoundTitle--ncwd2","notFoundContent":"cardList-module__notFoundContent--tjJEo"};